// Turning Marketing Studio output into something the send endpoints take.

const clean = (s) => s.replace(/[*_`]/g, '').replace(/^["“]|["”]$/g, '').trim();

// The email prompt asks for a subject line, preview text and a body in one blob.
// Pulls the subject out, drops the preview line, and returns the rest as the body.
export function splitEmailCopy(output) {
  let subject = '';
  const body = [];
  (output || '').split('\n').forEach((line) => {
    const m = line.match(/^\W*(subject(?: line)?|preview(?: text)?|body)\W*:\s*(.*)$/i);
    if (!m) { body.push(line); return; }
    const label = m[1].toLowerCase();
    if (label.startsWith('subject') && !subject) subject = clean(m[2]);
    else if (label === 'body' && m[2].trim()) body.push(m[2]);
    // preview text and a bare "Body:" label are dropped
  });
  return { subject, body: body.join('\n').replace(/^\s+/, '').replace(/\n{3,}/g, '\n\n') };
}

const escapeHtml = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Plain text to a safe HTML body: blank lines split paragraphs, single newlines break lines.
// Merge tokens ({{name}}) pass through untouched; the server fills them.
export function textToHtml(text) {
  return String(text || '')
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, '<br>')}</p>`)
    .join('\n');
}

// Same three fields, same "there" fallback as the server's email merge (email_service.merge_values),
// for the text path, which has no server-side merge.
export function fillMergeFields(text, { name, email } = {}) {
  const full = (name || '').trim().replace(/\s+/g, ' ');
  const values = { name: full || 'there', first_name: full ? full.split(' ')[0] : 'there', email: email || '' };
  return String(text || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => (k in values ? values[k] : m));
}

// Bracketed leftovers such as [Your Name] that the model leaves for a person to fill in.
export const hasPlaceholders = (text) => /\[[^\]\n]{2,}\]/.test(text || '');

export const MERGE_HINT = 'Merge fields: {{name}}, {{first_name}}, {{email}}';

const pad = (n) => String(n).padStart(2, '0');
// <input type="datetime-local"> wants local "YYYY-MM-DDTHH:mm".
export const toLocalInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

// Tomorrow at 9:00 in the browser's zone, the default for "send later".
export function defaultSendTime(now = new Date()) {
  const d = new Date(now);
  d.setDate(d.getDate() + 1);
  d.setHours(9, 0, 0, 0);
  return toLocalInput(d);
}

// The picked local time as a UTC ISO string for the API, or null when it is blank, not a date,
// or less than the server's two minutes of notice away.
export function scheduleIso(local, now = new Date()) {
  const d = local ? new Date(local) : null;
  if (!d || Number.isNaN(d.getTime()) || d.getTime() < now.getTime() + 2 * 60 * 1000) return null;
  return d.toISOString();
}
